import React from 'react';
import { Box, Container } from '@mui/material';
import { HEADER } from '@/config';
import BoletiaFooter from '@/components/BoletiaFooter';

function CheckoutHomeDesktopLayout({ children }) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        backgroundImage: (theme) =>
          `linear-gradient(to right, ${theme.palette.background.default} 25% , ${
            theme.palette.mode === 'light'
              ? theme.palette.grey[50]
              : theme.palette.grey[700]
          } 25%)`,
      }}
    >
      <Box
        sx={{
          height: HEADER.MAIN_DESKTOP_HEIGHT,
          width: '100%',
        }}
      ></Box>
      <Container
        maxWidth="lg"
        sx={{ height: `calc(100% - ${HEADER.MAIN_DESKTOP_HEIGHT}px)` }}
      >
        {children}
      </Container>
      <BoletiaFooter />
    </Box>
  );
}

export default CheckoutHomeDesktopLayout;
